import { useState, useContext } from "react";
import LoginInput from "./LoginInput";
import { useNavigate } from "react-router-dom";
import Context from "../../storage/context";

import axios from "axios";
const CheckIcon = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

function validate(email, password) {
  const errors = {};
  if (!email) errors.email = "נדרשת כתובת אימייל";
  else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) errors.email = "כתובת אימייל לא תקינה";
  if (!password) errors.password = "נדרשת סיסמה";
  else if (password.length < 6) errors.password = "הסיסמה חייבת להכיל לפחות 6 תווים";
  return errors;
}

function validateLogin() {
  const errors = {};
  errors.email = "";
  errors.password = "שם משתמש או סיסמא אינם תקינים!";
  return errors;
}

export default function LoginForm({ onSuccess }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  let navigate = useNavigate();
  const ctx = useContext(Context);

  const handleSubmit = async e => {
    e.preventDefault();
    const errs = validate(email, password);
    if (Object.keys(errs).length) { setErrors(errs); return; }
    setErrors({});
    setLoading(true);
    let response = "";
    try {
      response = await axios.post(`${ctx.api_url}/login`, { email, password });

    } catch (err) { }
    if (response.status !== 200) {
      if (response.status === 403) {
        navigate("/", { replace: true });
      }
      setErrors(validateLogin()); setLoading(false); return;
    } else {
      localStorage.setItem("token", response.data.token);
      setLoading(false);
      onSuccess?.()
    }
    ;
  };

  return (
    <form className="login-form" onSubmit={handleSubmit} noValidate>
      <LoginInput
        label="שם משתמש"
        type="email"
        icon="user"
        value={email}
        onChange={v => { setEmail(v); if (errors.email) setErrors(p => ({ ...p, email: "" })); }}
        error={errors.email}
      />

      <LoginInput
        label="סיסמה"
        type="password"
        icon="password"
        placeholder="הסיסמה שלך"
        value={password}
        onChange={v => { setPassword(v); if (errors.password) setErrors(p => ({ ...p, password: "" })); }}
        error={errors.password}
      />

      <div className="login-row">
        {/* <label className="login-remember" onClick={() => setRemember(v => !v)}>
          <div className={`login-remember__box${remember ? " login-remember__box--checked" : ""}`}>
            {remember && <CheckIcon />}
          </div>
          זכור אותי
        </label> 
        <button type="button" className="login-forgot">שכחת סיסמה?</button> */}
      </div>

      <button type="submit" className="login-submit" disabled={loading}>
        {loading ? (
          <>מתחבר<span className="login-submit__spinner" /></>
        ) : "כניסה לחשבון"}
      </button>

    </form>
  );
}
